const withAuthHeader = (includeHeaderKey = true) => {
    const sessionUser = JSON.parse(localStorage.getItem('auth'))
    if (sessionUser) {
        const auth = `${sessionUser.type} ${sessionUser.accessToken}`
        if (includeHeaderKey) {
            return {
                headers: {
                    Authorization: auth
                }
            }
        } else {
            return {
                Authorization: auth
            }
        }
    }
    return null;
}

export default withAuthHeader;